"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatisticTriggers = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var box_1 = require("../../../../controls/box");
var label_1 = require("../../../../controls/label");
var constants_1 = require("../../../../constants/constants");
var letsachieve_1 = require("../../../../api/letsachieve");
var statistic_dropdown_1 = require("../../../../components/form/statistic-dropdown");
var react_redux_1 = require("react-redux");
var main_1 = require("../../../../reducers/slices/main");
var StatisticTriggers = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_2.useState)(false), isEditing = _a[0], setIsEditing = _a[1];
    var _b = (0, react_2.useState)(false), enabled = _b[0], setEnabled = _b[1];
    var _c = (0, react_2.useState)([]), allowlist = _c[0], setAllowlist = _c[1];
    // shares its cache entry with the timezone panel beside it, so the app is fetched once for the page
    var _d = (0, letsachieve_1.useGetAppQuery)(), app = _d.data, isLoadingApp = _d.isLoading;
    var updateApp = (0, letsachieve_1.useUpdateAppMutation)()[0];
    var enabledOptions = [
        { label: "No", value: "false" },
        { label: "Yes", value: "true" },
    ];
    // seeds the fields once loaded, and only while not editing, so a refetch cannot overwrite pending edits
    (0, react_2.useEffect)(function () {
        var _a, _b;
        if (!(app === null || app === void 0 ? void 0 : app.statistic_triggers) || isEditing)
            return;
        setEnabled((_a = app.statistic_triggers.enabled) !== null && _a !== void 0 ? _a : false);
        setAllowlist((_b = app.statistic_triggers.allowlist) !== null && _b !== void 0 ? _b : []);
    }, [app, isEditing]);
    var showLoader = function () {
        dispatch((0, main_1.setContentModal)({
            title: "Please Wait...",
            content: (0, jsx_runtime_1.jsx)(react_1.Spinner, {}),
        }));
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!isEditing) {
                        return [2 /*return*/, setIsEditing(true)];
                    }
                    showLoader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateApp({
                            statistic_triggers: {
                                enabled: enabled,
                                allowlist: allowlist.length > 0 ? allowlist : undefined,
                            },
                        }).unwrap()];
                case 2:
                    _b.sent();
                    dispatch((0, main_1.setContentModal)(null));
                    setIsEditing(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    dispatch((0, main_1.setContentModal)({ title: constants_1.REQUEST_ERROR_TITLE, content: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.error) !== null && _a !== void 0 ? _a : "The request was unsuccessful." }) }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    if (isLoadingApp) {
        return ((0, jsx_runtime_1.jsx)(box_1.Box, { className: "flex flex-auto bg-white", children: (0, jsx_runtime_1.jsx)(react_1.Spinner, {}) }));
    }
    return ((0, jsx_runtime_1.jsx)(box_1.Box, { className: "flex flex-auto bg-white", children: (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-4 flex-auto", children: (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col lg:flex-row", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-1 flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex gap-4 bg-white", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-2", children: [(0, jsx_runtime_1.jsx)(label_1.Label, { label: "Forward Statistic Events", textColor: "text-black", size: "small", bold: true }), (0, jsx_runtime_1.jsx)(label_1.Label, { label: "Controls whether statistic changes are forwarded to Let's Trade. When disabled, no statistic events are sent. When enabled with an allowlist, only listed statistics are forwarded.", textColor: "text-gray-500", size: "small" }), (0, jsx_runtime_1.jsx)(react_1.RadioGroup, { value: enabled ? "true" : "false", onChange: function (value) {
                                                    if (!isEditing)
                                                        return;
                                                    setEnabled(value === "true");
                                                }, isDisabled: !isEditing, orientation: "horizontal", children: enabledOptions.map(function (option) { return ((0, jsx_runtime_1.jsxs)(react_1.Radio, { value: option.value, children: [(0, jsx_runtime_1.jsx)(react_1.Radio.Control, { children: (0, jsx_runtime_1.jsx)(react_1.Radio.Indicator, {}) }), (0, jsx_runtime_1.jsx)(react_1.Radio.Content, { children: (0, jsx_runtime_1.jsx)(react_1.Label, { children: option.label }) })] }, option.value)); }) })] }), (0, jsx_runtime_1.jsx)(statistic_dropdown_1.StatisticDropdown, { label: "Statistic Allowlist (leave empty to forward all)", placeholder: "All statistics (none selected)", selectedNames: allowlist, onSelectionChange: setAllowlist, isDisabled: !isEditing || !enabled, isMultiple: true })] }) }), (0, jsx_runtime_1.jsx)("div", { className: "flex flex-row items-center gap-4", children: (0, jsx_runtime_1.jsx)("div", { className: "w-[100px]", children: (0, jsx_runtime_1.jsx)(react_1.Button, { size: "md", variant: "primary", onPress: handleSave, children: isEditing ? "Done" : "Edit" }) }) })] }) }) }) }));
};
exports.StatisticTriggers = StatisticTriggers;
